import React from 'react';

const SKELETON_ROWS = 5;

const SmartTableLoading: React.FC = () => {
  return (
    <div className="st-loading-container" aria-hidden="true">
      {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
        <div key={i} className="st-skeleton-row st-shimmer" />
      ))}
    </div>
  );
};

export default SmartTableLoading;